// extracted by mini-css-extract-plugin
export default {"main":"DoctorListCard_main__X0-VJ","btn":"DoctorListCard_btn__fx6xR","formDiv":"DoctorListCard_formDiv__R6MJ+","input-group":"DoctorListCard_input-group__4LqEF"};